module.exports = __webpack_public_path__ + "static/media/back_green.323dd042.jpg";